// api-calls.js
import UserApi from "./user-api";
import ContactApi from "./contact-api";
import MessageApi from "./message-api";
import ThreadApi from "./thread-api";
import OrganizationApi from "./organization-api";
import ExternalAccessApi from "./external-access-api";

const ApiCalls = {
  user: UserApi,
  contact: ContactApi,
  message: MessageApi,
  thread: ThreadApi,
  organization: OrganizationApi,
  externalAccess: ExternalAccessApi,
};

export default ApiCalls;
